import { useTranslation } from 'react-i18next';
import {
  useFormContext,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { ValidationOptions } from '../../../types/form';
import { applyCheckboxGroupValidationOptions } from './applyCheckboxGroupValidationOptions';

export type CheckboxGroupFieldValidationOptions<TFieldValues> =
  ValidationOptions<TFieldValues> & {
    atLeastOne?: boolean;
  };

export interface UseCheckboxGroupFieldControllerProps<TFieldValues>
  extends Omit<UseControllerProps<TFieldValues>, 'control' | 'rules'> {
  rules?: CheckboxGroupFieldValidationOptions<TFieldValues>;
}

export function useCheckboxGroupFieldController<TFieldValues>(
  props: UseCheckboxGroupFieldControllerProps<TFieldValues>,
) {
  const { rules = {}, name, ...restControllerProps } = props;

  const { t } = useTranslation();
  const { control, getValues } = useFormContext<TFieldValues>();

  const checkboxGroupFieldRules =
    applyCheckboxGroupValidationOptions<TFieldValues>(
      name,
      getValues,
      t,
      rules,
    );
  const required = checkboxGroupFieldRules.atLeastOne;

  const controllerProps = useController<TFieldValues>({
    name,
    control,
    rules: checkboxGroupFieldRules,
    ...restControllerProps,
  });

  return {
    required,
    ...controllerProps,
  };
}
